export default __webpack_public_path__ + "b783b98e46715dd5fa7658f4056bbb8f.svg";